import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const importotherDetailsApi = createApi({
  reducerPath: "importotherDetailsApi",
  baseQuery,
  tagTypes: ["OtherDetails"],
  endpoints: (builder) => ({
    // GET
    getOtherDetailsById: builder.query({
      query: ({id}) => `import/product/otherdetails/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        return data
      },
    providesTags: ["OtherDetails"],
    }),

    // CREATE
    createOtherDetail: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `import/product/otherdetails/${id}`,
        method: "PUT",
        body: { importProductOtherDetails:data },
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["OtherDetails"],
    }),
  }),
});

export const {
  useLazyGetOtherDetailsByIdQuery,
  useCreateOtherDetailMutation,
} = importotherDetailsApi;
